/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable @next/next/no-img-element */
"use client";
import { useState } from "react";

// Funzione di validazione molto semplice per le e-mail
const validateEmail = (value: string) => {
  // Regex basilare che controlla che ci sia un @ e un . nel punto giusto
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(value.trim());
};

export default function Footer() {
  // Stato per memorizzare l'e-mail
  const [email, setEmail] = useState("");
  // Stato per mostrare il messaggio di conferma
  const [showSuccess, setShowSuccess] = useState(false);
  // Stato per mostrare eventuale errore email non valida
  const [errorEmail, setErrorEmail] = useState("");

  // Funzione per inviare la newsletter
  const sendNewsletter = async () => {
    // Se l’email non è valida, mostriamo l’errore
    if (!validateEmail(email)) {
      setErrorEmail("Inserisci un indirizzo email valido.");
      return;
    }
    // Altrimenti, puliamo l’errore e proseguiamo
    setErrorEmail("");
    console.log("Email inviata (in fase di invio al server):", email);

    try {
      // Esegui la GET verso il tuo endpoint, sostituendo {email} con l'indirizzo inserito
      const response = await fetch(
        `https://a2i7x2.emailsp.com/frontend/xmlSubscribe.aspx?list=3&group=45&email=${encodeURIComponent(
          email
        )}&confirm=false`
      );

      if (!response.ok) {
        // Se la risposta non è ok, solleva un errore
        throw new Error("Request failed");
      }

      // Se tutto va bene, mostriamo il messaggio di successo
      setShowSuccess(true);
      // Nascondi il messaggio dopo 1 secondo
      setTimeout(() => setShowSuccess(false), 1000);
    } catch (error) {
      // Se qualcosa va storto, mostriamo un errore generico
      setErrorEmail("Errore durante l'iscrizione, riprova più tardi.");
      console.error("Errore newsletter:", error);
    }
  };

  // // 1) Funzione per aprire la Privacy su Firebase con window.open
  // const handleOpenPrivacy = () => {
  //   const firebasePrivacyURL =
  //     "https://firebasestorage.googleapis.com/v0/b/balu-4523d.appspot.com/o/privacy.html?alt=media&token=888a51fb-07c3-4c14-945a-0e15e72e2d30";
  //   window.open(firebasePrivacyURL, "_blank", "noopener,noreferrer");
  // };

  // 2) Funzione per aprire le Condizioni generali di contratto su Firebase
  // (eventualmente aggiungila se serve)

  return (
    <>
      {/* Footer: “Scarica l’app di Babalù®” + links */}
      <footer id="contatti" className="relative font-paragraph">
        {/* Footer Superiore - Gradiente */}
        <div className="w-full absolute -top-[4.5rem] md:-top-16 right-0 px-4 md:px-0">
          <div className="bg-gradient-to-r from-[#026E78] to-[#009E96] rounded-3xl border border-white max-w-sm md:max-w-3xl lg:max-w-6xl w-full mx-auto">
            <div className="w-full flex flex-col items-center justify-center md:flex-row md:justify-between p-4 lg:py-10">
              <h3 className="font-heading text-xl sm:text-3xl font-bold mb-3 sm:mb-0 text-white text-center md:text-left">
                Scarica l’app di Babalù®
              </h3>

              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <p className="font-paragraph text-sm sm:text-base text-white text-center md:text-left">
                  Il mondo Pet, tutto
                  <br className="hidden md:block" /> in una sola app. —
                </p>
                <div className="flex gap-3">
                  <a href="https://babalu.app.link/RIwUUgvPsIb">
                    <img
                      src="/assets/home-store-white.svg"
                      alt="Google Play"
                      className="w-28 sm:w-36 h-auto"
                    />
                  </a>
                  <a href="https://babalu.app.link/RIwUUgvPsIb">
                    <img
                      src="/assets/home-appstore-white.svg"
                      alt="App Store"
                      className="w-28 sm:w-36 h-auto"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#026E78] text-white pt-24 sm:pt-32 pb-10 items-center justify-center">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 mb-8 text-center">
            <p className=" font-paragraph text-xs max-w-6xl leading-relaxed mb-2">
              Il progetto Babalù® è stato realizzato con il contributo
              dell’Unione Europea <br className="hidden md:block" /> – Fondo
              Europeo di Sviluppo Regionale (PR FESR Liguria 2021-2027).
            </p>

            <img
              src="/assets/footer-banner.png"
              alt="Footer Banner"
              className="mx-auto w-[700px] h-auto pb-4"
            />
          </div>

          {/* --- DESKTOP FOOTER --- */}
          <div className="hidden md:grid max-w-6xl mx-auto px-4 sm:px-6 grid-cols-1 md:grid-cols-4 gap-8 pb-10">
            <div>
              <img
                src="/assets/home-footer-logo.svg"
                alt="Babalù® Logo"
                className="w-24 h-auto mb-3"
              />
              <p className="font-paragraph text-sm leading-relaxed">
                Il mondo del tuo Pet, sempre con te.{" "}
                <br className="md:hidden" /> Gestione, community, challenge,
                sconti e servizi. In un’unica app. Pensata per chi ama davvero
                gli animali.
              </p>
              <div className="flex gap-3 mt-3">
                <a
                  href="https://www.facebook.com/babaluapp.it/?ref=embed_page"
                  className="font-paragraph"
                >
                  <img
                    src="/assets/home-footer-fb.svg"
                    alt="Facebook"
                    className="w-6 h-6"
                  />
                </a>
                <a
                  href="https://www.instagram.com/babalu.app?igsh=MWZneGxsMjUxc2c2bQ=="
                  className="font-paragraph"
                >
                  <img
                    src="/assets/home-footer-instagram.svg"
                    alt="Instagram"
                    className="w-6 h-6"
                  />
                </a>
                <a
                  href="https://www.tiktok.com/login?redirect_url=https%3A%2F%2Fwww.tiktok.com%2F%40babalu.app&lang=en&enter_method=mandatory"
                  className="font-paragraph"
                >
                  <img
                    src="/assets/home-footer-tiktok.svg"
                    alt="TikTok"
                    className="w-6 h-6"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A96041159&keywords=babal%C3%B9%20app&origin=RICH_QUERY_SUGGESTION&position=0&searchId=37f83b6f-f03b-4d6c-8fc4-3665ce139d7f&sid=1kM&spellCorrectionEnabled=false"
                  className="font-paragraph"
                >
                  <img
                    src="/assets/linkedin.svg"
                    alt="telegram"
                    className="w-6 h-6"
                  />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xl font-bold mb-4">
                Il mondo di Babalù®
              </h4>
              <ul className="font-paragraph space-y-4 text-sm ">
                <li>
                  <a href="/" className="font-paragraph ">
                    Homepage
                  </a>
                </li>
                <li>
                  <a href="/#cosapuoifare" className="font-paragraph">
                    Servizi
                  </a>
                </li>
                <li>
                  <a href="/challenges" className="font-paragraph">
                    Challenge
                  </a>
                </li>
                <li>
                  <a href="/rewards/" className="font-paragraph">
                    Promozioni
                  </a>
                </li>
                {/* <li>
                  <a href="/mission-partner" className="font-paragraph">
                    Mission Partner
                  </a>
                </li> */}
                {/*<li>*/}
                {/*  <a href="/#contatti" className="font-paragraph">*/}
                {/*    Contatti*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-xl font-bold mb-2">
                Informazioni utili
              </h4>
              <ul className="font-paragraph space-y-4 text-sm">
                {/* Link Privacy Policy */}
                <li>
                  <a
                    href="/privacy-policy"
                    className="font-paragraph"
                  >
                    Privacy & Cookie Policy
                  </a>
                </li>

                {/* Link Condizioni generali di contratto */}
                <li>
                  <a href="/termini-e-condizioni" className="font-paragraph">
                    Termini e condizioni
                  </a>
                </li>

                <li>
                  <a href="/termini-e-condizioni-ecommerce" className="font-paragraph">
                    Termini e condizioni di vendita
                  </a>
                </li>

                <li>
                  <a
                    href="/regolamento-con-babalu-vinci"
                    className="font-paragraph"
                  >
                    Regolamenti &quot;Con Babalù® Vinci&quot;
                  </a>
                </li>

                <li>
                  <a href="/return-policy" className="font-paragraph">
                    Diritto di recesso
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-xl font-bold mb-2">
                Babaletter
              </h4>
              <p className="font-paragraph text-sm leading-relaxed">
                Promozioni esclusive, consigli utili e curiosità dal mondo Pet.
                Nessuna noia, zero spam. Solo cose che ti (e gli) fanno bene.
                #PetLover
              </p>

              {/* Container con messaggio + input + button */}
              <div className="flex flex-col mt-3">
                {/* Messaggio di errore, appare se errorEmail è pieno */}
                {errorEmail && (
                  <div className="bg-red-600 text-white px-2 py-1 text-sm rounded mb-2 text-center font-paragraph">
                    {errorEmail}
                  </div>
                )}

                {/* Messaggio di conferma, appare se showSuccess === true */}
                {showSuccess && (
                  <div className="bg-green-700 text-white px-2 py-1 rounded mb-2 text-center">
                    Registrazione avvenuta con successo
                  </div>
                )}

                <div className="flex">
                  <input
                    type="email"
                    placeholder="Il tuo indirizzo e-mail"
                    className="font-paragraph border border-gray-300 text-gray-800 px-3 py-2 text-sm w-full rounded-xl mr-2 outline-none"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    onClick={sendNewsletter}
                    className="font-paragraph bg-[#EA5D39] text-white px-4 py-2 rounded-xl text-sm"
                  >
                    Iscriviti
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* --- FOOTER MOBILE --- */}
          <div className="block md:hidden bg-[#026E78] text-white px-6 pb-5">
            <img
              src="/assets/home-footer-logo.svg"
              alt="logo white"
              className="pb-4"
            />
            <p className="font-paragraph text-sm leading-relaxed pb-2">
              Il mondo del tuo Pet, sempre con te. <br className="md:hidden" />{" "}
              Gestione, community, challenge, sconti e servizi. In un’unica app.
              Pensata per chi ama davvero gli animali.
            </p>
            <div className="flex gap-3 mt-3">
              <a
                href="https://www.facebook.com/babaluapp.it/?ref=embed_page"
                className="font-paragraph"
              >
                <img
                  src="/assets/home-footer-fb.svg"
                  alt="Facebook"
                  className="w-6 h-6"
                />
              </a>
              <a
                href="https://www.instagram.com/babalu.app?igsh=MWZneGxsMjUxc2c2bQ=="
                className="font-paragraph"
              >
                <img
                  src="/assets/home-footer-instagram.svg"
                  alt="Instagram"
                  className="w-6 h-6"
                />
              </a>
              <a
                href="https://www.tiktok.com/login?redirect_url=https%3A%2F%2Fwww.tiktok.com%2F%40babalu.app&lang=en&enter_method=mandatory"
                className="font-paragraph"
              >
                <img
                  src="/assets/home-footer-tiktok.svg"
                  alt="TikTok"
                  className="w-6 h-6"
                />
              </a>
              <a
                href="https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A96041159&keywords=babal%C3%B9%20app&origin=RICH_QUERY_SUGGESTION&position=0&searchId=37f83b6f-f03b-4d6c-8fc4-3665ce139d7f&sid=1kM&spellCorrectionEnabled=false"
                className="font-paragraph"
              >
                <img
                  src="/assets/linkedin.svg"
                  alt="telegram"
                  className="w-6 h-6"
                />
              </a>
            </div>
            <div className="mb-6 mt-4">
              <h4 className="font-heading text-xl font-semibold mb-2">
                Babaletter
              </h4>
              <p className="font-paragraph text-sm leading-relaxed">
                Promozioni esclusive, consigli utili e curiosità dal mondo Pet.
                Nessuna noia, zero spam. Solo cose che ti (e gli) fanno bene.
                #PetLover
              </p>

              {/* Container con messaggio + input + button (mobile) */}
              <div className="flex flex-col mt-3 gap-2">
                {/* Messaggio di errore, appare se errorEmail è pieno */}
                {errorEmail && (
                  <div className="bg-red-600 text-white px-2 py-2 text-sm rounded text-center font-paragraph">
                    {errorEmail}
                  </div>
                )}

                {/* Messaggio di conferma, appare se showSuccess === true */}
                {showSuccess && (
                  <div className="bg-[#EA5D39] text-white px-2 py-1 rounded text-center">
                    Email inviata!
                  </div>
                )}

                <input
                  type="email"
                  placeholder="Il tuo indirizzo e-mail"
                  className="font-paragraph border border-gray-300 text-gray-800 px-3 py-2 text-sm w-full rounded-2xl outline-none"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  onClick={sendNewsletter}
                  className="font-paragraph bg-[#EA5D39] text-white px-4 py-3 font-extrabold rounded-2xl text-xl w-full"
                >
                  Iscriviti
                </button>
              </div>
            </div>

            <div className="mt-6">
              <h4 className="font-heading font-semibold mb-2 text-xl ">
                Il mondo di Babalù®
              </h4>
              <ul className="font-paragraph space-y-3 text-md">
                <li>
                  <a href="/" className="font-paragraph">
                    Homepage
                  </a>
                </li>
                <li>
                  <a href="/#cosapuoifare" className="font-paragraph">
                    Servizi
                  </a>
                </li>
                <li>
                  <a href="/challenges" className="font-paragraph">
                    Challenge
                  </a>
                </li>
                <li>
                  <a href="/rewards/" className="font-paragraph">
                    Promozioni
                  </a>
                </li>
                {/* <li>
                  <a href="/mission-partner" className="font-paragraph">
                    Mission Partner
                  </a>
                </li> */}
                {/*<li>*/}
                {/*  <a href="/#contatti" className="font-paragraph">*/}
                {/*    Contatti*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
            </div>

            <div className="mt-6">
              <h4 className="font-heading text-xl font-semibold mb-2">
                Informazioni utili
              </h4>
              <ul className="font-paragraph space-y-3 text-md">
                {/* Link Privacy Policy */}
                <li>
                  <a
                    href="/privacy-policy"
                    className="font-paragraph"
                  >
                    Privacy & Cookie Policy
                  </a>
                </li>

                {/* Link Condizioni generali di contratto */}
                <li>
                  <a href="/termini-e-condizioni" className="font-paragraph">
                    Termini e condizioni
                  </a>
                </li>

                <li>
                  <a href="/termini-e-condizioni-ecommerce" className="font-paragraph">
                    Termini e condizioni di vendita
                  </a>
                </li>

                <li>
                  <a
                    href="/regolamento-con-babalu-vinci"
                    className="font-paragraph"
                  >
                    Regolamenti &quot;Con Babalù® Vinci&quot;
                  </a>
                </li>

                <li>
                  <a href="/return-policy" className="font-paragraph">
                    Diritto di recesso
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full border-t border-white opacity-20 my-6"></div>
          <div className="font-paragraph text-xs text-center opacity-80 px-4 sm:px-0">
            Tutti i diritti riservati © {new Date().getFullYear()} Babalù® |
            BABALÙ S.R.L. <span className="pr-8 hidden md:block"></span> P.IVA:
            13444070968 | Provincia: LO | Comune: Lodi | Indirizzo: Viale Pavia
            16 | Cap: 26900 | E-Mail:{" "}
            <a href="mailto:info@babalu.it" className="font-paragraph">
              info@babalu.it
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
